var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SubjectLayout', {
    staticClass: "collection-select",
    class: {
      'collection-select--disabled': _vm.computedDisabled
    },
    attrs: {
      "subject": _vm.subject,
      "validateError": _vm.validateError
    }
  }, [_vm.isFetchingData ? _c('div', {
    staticClass: "collection-select__loading-wrapper"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : [_vm.presentationType === 'select' ? _c('SharedSelect', {
    attrs: {
      "options": _vm.options,
      "hasBorder": false,
      "placeholder": _vm.placeholder,
      "disabled": _vm.subject.disabled
    },
    on: {
      "input": _vm.handleSelectValueChanged
    },
    model: {
      value: _vm.selectedSelectValue,
      callback: function callback($$v) {
        _vm.selectedSelectValue = $$v;
      },
      expression: "selectedSelectValue"
    }
  }) : _vm._e(), _vm.presentationType === 'radio' ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 -0.5rem"
    }
  }, _vm._l(_vm.options, function (option, optionIndex) {
    return _c('div', {
      key: optionIndex,
      staticClass: "col-12 col-sm-6 px-2"
    }, [_c('SharedRadioButton', {
      attrs: {
        "id": _vm.subject.id + '-' + optionIndex,
        "value": optionIndex.toString(),
        "name": _vm.subject.id,
        "disabled": option.disabled
      },
      on: {
        "change": function change($event) {
          return _vm.handleRadioValueChanged(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")])], 1);
  }), 0) : _vm._e(), _vm.presentationType === 'checkbox' ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 -0.5rem"
    }
  }, _vm._l(_vm.options, function (option, optionIndex) {
    return _c('div', {
      key: optionIndex,
      staticClass: "col-12 col-sm-6 px-2"
    }, [_c('SharedCheckbox', {
      attrs: {
        "id": _vm.subject.id + '-' + optionIndex,
        "value": optionIndex.toString(),
        "name": _vm.subject.id,
        "disabled": option.disabled
      },
      on: {
        "input": _vm.handleCheckboxValueChanged
      },
      model: {
        value: _vm.selectedCheckboxValue,
        callback: function callback($$v) {
          _vm.selectedCheckboxValue = $$v;
        },
        expression: "selectedCheckboxValue"
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")])], 1);
  }), 0) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }